// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"5fd11c72","63":"2070073a","188":"87e1825e","728":"254f0668","823":"f6542dbb","927":"f01bd266"}[chunkId] + ".css";
};